import React from "react";
export default function () {
    return (
        <svg width="200" height="200" viewBox="0 0 200 200">
            <g>
                <path d="M24.2,100.2c-11.7-10.9-.4-18,8.8-13.1C20.6,70.9,20.6,73.4,30.5,58.6L16.7,39.3a1.3,1.3,0,0,0-1.3,1.1c6.9,9.4,9.4,13-2.5,24.9,0,0,10.3,11.1,12.3,15,0,0-13.6-5.8-12.7,8.5.4,6.4,6.9,10.4,11.3,11.9C24,101.1,24.3,100.5,24.2,100.2Z" />
                <circle cx="45" cy="84" r="4" />
            </g>
        </svg>
    );
}
